// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CatalogFeed } from './catalog-feed';
import { Manufacturer } from './manufacturer';
import { ProductType } from './product-type';
import { StagedFeedRun } from './staged-feed-run';
import { StagedProductColor } from './staged-product-color';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StagedProductType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(100) */
  brand?: string;
  /** Int32 FK catalogFeed */
  catalogFeedId!: number;
  /** String */
  description?: string;
  /** String(1000) */
  fetchError?: string;
  /** Int32 */
  fetchErrorKind?: number;
  /** DateTimeOffset */
  lastChangeDate?: Date;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** String(500) */
  primaryImageUrl?: string;
  /** String(400) */
  productName?: string;
  /** Int32 FK productType */
  productTypeId?: number;
  /** DateTimeOffset */
  snapshotTs!: Date;
  /** Int32 FK stagedFeedRun */
  stagedFeedRunId!: number;
  /** String(50) */
  style!: string;
  /** FK catalogFeedId */
  catalogFeed!: CatalogFeed;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK stagedFeedRunId */
  stagedFeedRun!: StagedFeedRun;
  /** Inv FK stagedProductTypeId */
  stagedProductColors!: StagedProductColor[];
}

